module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HomeView'
      }
    }
  }, [_vm._v("\n      NLP Dataset Explorer\n    ")])], 1), _vm._v(" "), (_vm.showOptions) ? _c('ul', {
    staticClass: "nav-options"
  }, [_vm._l((_vm.datasets), function(d) {
    return [_c('li', {
      on: {
        "click": _vm.onLoadOption
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'HomeView',
          query: {
            dataset: d
          }
        }
      }
    }, [_vm._v(_vm._s(d))])], 1)]
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.showOptions) ? _c('ul', {
    staticClass: "nav"
  }, [_c('li', [_vm._v(_vm._s(_vm.dataset))])]) : _vm._e(), _vm._v(" "), (!_vm.showOptions) ? _c('ul', {
    staticClass: "nav-more"
  }, [_c('li', {
    on: {
      "click": _vm.onShowOptions
    }
  }, [_vm._v("More")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cf8493a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 76
// module chunks = 1